import { styled } from '@obvio/app'
import { RichText } from '@obvio/template'
import { Button, Stack } from '@obvio/ui'

import { useCursorContext } from './Cursor'

import type { ImageAsset } from '@obvio/app'
import type { AllowUndefinedForOptional } from '@obvio/utils'
import type { ReactElement } from 'react'

const Wrap = styled.div<{ $bgUrl: string }>`
  width: 100vw;
  height: 33rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  * {
    color: white;
  }
  :before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${(_, { $bgUrl }) => $bgUrl});
    background-size: cover;
    background-position: center;
    filter: brightness(0.3);
  }
`

const Content = styled(Stack)`
  position: relative;
  max-width: 46rem;
  text-align: center;
`

const ButtonsWrap = styled.div`
  display: flex;
  justify-content: space-around;
`

type CtaBannerProps = AllowUndefinedForOptional<{
  Image: ImageAsset[]
  Text: string
  pageId: string
  ctaText1?: string
  url1?: string
  ctaText2?: string
  url2?: string
}>

export function CtaBanner({
  Image: image,
  Text: text,
  pageId,
  ctaText1,
  url1,
  ctaText2,
  url2,
}: CtaBannerProps): ReactElement {
  const bgUrl = `/page/${pageId}/${image?.[0]?.name}`
  const { setKind } = useCursorContext()
  return (
    <Wrap
      $bgUrl={bgUrl}
      onMouseOver={() => setKind('white')}
      onMouseLeave={() => setKind('black')}
    >
      <Content kind="vertical" spacing="large">
        <div>
          <RichText value={text} asMap={{ h3: 'sub-h1' }} />
        </div>
        <ButtonsWrap>
          {ctaText1 && url1 ? (
            <Button kind="ghost" href={url1}>
              {ctaText1}
            </Button>
          ) : null}
          {ctaText2 && url2 ? (
            <Button kind="ghost" href={url2}>
              {ctaText2}
            </Button>
          ) : null}
        </ButtonsWrap>
      </Content>
    </Wrap>
  )
}
